module.exports = __webpack_public_path__ + "img/attention.f8d067a7.svg";